<template>
  <v-card class="elevation-12" style="margin-top: 10px">
    <v-card-text>
      <form :id="idForm">
        <h3>{{ $t('Amount') }}: <span>{{ amount }}</span></h3>
        <div :id="idCard" class="mt-5 mb-5">
          <!--Stripe.js injects the Card Element-->
        </div>
        <v-alert v-if="error" type="error" dismissible>
          {{ error }}
        </v-alert>
        <v-btn color="secondary" class="ml-2 black--text" style="margin-right: 15px" @click="cancel">
          {{ $t('Cancel') }}
        </v-btn>
        <v-btn :id="idBtn" class="btn-primary" dark type="submit" :loading="loading" :disabled="disabled">
          {{ $t('Pay') }}
        </v-btn>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
import Constants from "../../constants";
import ApiRepository from "@/repositories/ApiRepository";
export default {
    name: "Payment",
    props: {
        collateral: {
            type: String,
            required: false,
            default: ''
        },
        factoring: {
            type: Object,
            required: false,
            default: null
        },
        amount: {
            type: Number,
            required: true
        },
        user: {
            type: Object,
            required: false,
            default: null
        },
        idForm: {
            type: String,
            required: false,
            default: 'payment-form'
        },
        idCard: {
            type: String,
            required: false,
            default: 'card-element'
        },
        idBtn: {
            type: String,
            required: false,
            default: 'submit'
        },
        chat: {
            type: Object,
            required: false,
            default: null
        }

    },
    data () {
        return {
            stripeAPIToken: Constants.STRIPE_PUBLIC_KEY,
            stripe: '',
            elements: '',
            card: '',
            loading: false,
            error: false,
            disabled: false
        };
    },
    mounted () {
        this.includeStripe('js.stripe.com/v3/', () => {
            this.configureStripe();
        });
    },
    methods: {
        cancel () {
            console.log('event cancel');
            this.$emit('cancel');
        },
        includeStripe ( URL, callback ) {
            const documentTag = document, tag = 'script',
                object = documentTag.createElement(tag),
                scriptTag = documentTag.getElementsByTagName(tag)[0];
            object.src = '//' + URL;
            if (callback) { object.addEventListener('load', (e) => { callback(null, e); }, false); }
            scriptTag.parentNode.insertBefore(object, scriptTag);
        },
        configureStripe () {
            let userId = null;
            let chatId = null;
            if (this.user) {
                this.stripe = window.Stripe(this.user.stripePublickey);
                userId = this.user._id;
            } else if (this.chat) {
                this.stripe = window.Stripe(this.chat.paymentInformation.stripePublicKey);
                chatId = this.chat._id;
            }else {
                this.stripe =  window.Stripe(this.stripeAPIToken);
            }
            ApiRepository.paymentIntent(this.amount, userId, chatId)
                .then((response) => {
                    const elements = this.stripe.elements();
                    const style = {
                        base: {
                            color: "#32325d",
                            fontFamily: 'Arial, sans-serif',
                            fontSmoothing: "antialiased",
                            fontSize: "16px",
                            "::placeholder": {
                            }
                        },
                        invalid: {
                            fontFamily: 'Arial, sans-serif',
                            color: "#fa755a",
                        }
                    };
                    const card = elements.create("card", { style: style });
                    // Stripe injects an iframe into the DOM
                    card.mount("#" + this.idCard);
                    card.on("change", (event) => {
                        // Disable the Pay button if there are no card details in the Element
                        this.error = event.error ? event.error.message : "";
                    });
                    const form = document.getElementById(this.idForm);
                    form.addEventListener("submit", (event) => {
                        event.preventDefault();
                        this.loading = true;
                        // Complete payment when the submit button is clicked
                        this.payWithCard(this.stripe, card, response.data.clientSecret);
                    });
                }).catch((err) => {
                    console.log(err);
                    this.$root.$emit('show-snackbar', {message: this.$t(err.response.data.errorCode), color: "error"});
                });
        },
        payWithCard (stripe, card, clientSecret) {
            this.stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: card
                }
            }).then((result) => {
                this.loading = false;
                if (result.error) {
                    // Show error to your customer
                    this.error = result.error.message;
                    this.$root.$emit('show-snackbar', {message: this.$t('Error')});
                } else {
                    // The payment succeeded!
                    if (this.factoring) {
                        ApiRepository.addPayment(this.factoring.payer, this.factoring.receiver, Constants.PAYMENT_MODE.STRIPE, this.amount, result.paymentIntent.id, this.factoring._id, this.collateral)
                            .then((r) => {
                            })
                            .catch((e) => {
                                this.$root.$emit('show-snackbar', {message: this.$t('Error')});
                            });
                    }
                    this.disabled = true;
                    this.$root.$emit('show-snackbar', {message: this.$t('success')});
                    this.$emit('success');
                }
            });
        }
    }
};
</script>

<style scoped>

</style>
